import React from 'react';
import styles from './HomeTitle.module.scss';

export default class HomeTitle extends React.PureComponent {
    _getRoles() {
        const rolesRaw = [];
        for (let i = 0; i < this.props.roles.length; i++) {
            rolesRaw.push(
                <h2 key={'role-'.concat(i.toString())} className={styles.role}>
                    {this.props.roles[i]}
                </h2>
            );
            if (i < this.props.roles.length - 1)
                rolesRaw.push(
                    <span key={'span-'.concat(i.toString())}>·</span>
                );
        }
        return rolesRaw;
    }
    render() {
        return (
            <div className={styles['home-title']}>
                <div className={styles['logo-container']}>
                    <svg
                        className={styles.logo}
                        xmlns="http://www.w3.org/2000/svg"
                        width="507.12"
                        height="507.12"
                        viewBox="0 0 507.12 507.12"
                    >
                        <g fill="#DF003F">
                            <circle cx="253.56" cy="253.56" r="244.452" />
                            <path d="M253.56 507.12c-67.73 0-131.403-26.375-179.294-74.266C26.376 384.964 0 321.29 0 253.56S26.375 122.157 74.266 74.266C122.156 26.376 185.832 0 253.56 0c67.73 0 131.403 26.375 179.294 74.266 47.892 47.89 74.267 111.565 74.267 179.294s-26.374 131.403-74.266 179.294c-47.89 47.89-111.566 74.266-179.294 74.266zm0-488.905c-62.863 0-121.963 24.48-166.414 68.93-44.45 44.452-68.93 103.552-68.93 166.415 0 62.863 24.48 121.964 68.93 166.414 44.45 44.45 103.55 68.93 166.414 68.93 62.863 0 121.964-24.478 166.415-68.93 44.45-44.45 68.93-103.55 68.93-166.414 0-62.863-24.48-121.963-68.93-166.414-44.452-44.45-103.552-68.93-166.415-68.93z" />
                        </g>
                        <path
                            fill="#404041"
                            d="M9.107 253.56h488.905c0 135.007-109.445 244.452-244.452 244.452S9.107 388.567 9.107 253.56z"
                        />
                        <g>
                            <path
                                fill="#DF003F"
                                d="M405.396 253.56L302.776 430.8l-41.39-71.636L322.3 253.56h-15.006l-53.417 92.608-53.51-92.608H185.35l61.023 105.614-41.313 71.624L102.73 253.56H87.69l111.74 193.488c1.162 2.01 3.308 3.25 5.63 3.25s4.468-1.24 5.63-3.25l43.19-74.88 43.266 74.88c1.16 2.01 3.307 3.25 5.63 3.25s4.467-1.24 5.628-3.25L420.42 253.56h-15.024z"
                            />
                            <path
                                fill="#404041"
                                d="M102.714 253.56l102.62-177.24 41.39 71.636-60.913 105.604h15.007l53.417-92.608 53.51 92.608h15.015l-61.024-105.614 41.313-71.624L405.38 253.56h15.04L308.677 60.07c-1.16-2.01-3.307-3.25-5.63-3.25s-4.467 1.24-5.628 3.25l-43.192 74.88-43.265-74.88c-1.16-2.01-3.307-3.25-5.63-3.25s-4.467 1.24-5.628 3.25L87.69 253.56h15.024z"
                            />
                        </g>
                    </svg>
                </div>
                <h1 className="site-title">{this.props.name}</h1>
                {this._getRoles()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/home/title/HomeTitle.jsx